import React from 'react';
import { Skull, Sword, Shield, Zap } from 'lucide-react';

const EnemyPlacer = ({
  enemies = [],
  selectedEnemyId,
  setSelectedEnemyId,
  enemyInstances = []
}) => {
  const selectedEnemy = enemies.find(e => e.id === selectedEnemyId);

  // Calcular vida total del enemigo
  const getTotalHP = (enemy) => {
    return (enemy?.v_head || 0) + 
           (enemy?.v_torso || 0) + 
           (enemy?.v_arm_l || 0) + 
           (enemy?.v_arm_r || 0) + 
           (enemy?.v_leg_l || 0) + 
           (enemy?.v_leg_r || 0);
  };

  return (
    <section className="space-y-4">
      <h3 className="text-xs font-bold text-slate-500 uppercase tracking-widest flex items-center gap-2">
        <Skull size={14} /> Enemigos
      </h3>

      {/* Selector de enemigo */}
      <div className="space-y-2">
        <label className="text-xs font-semibold text-slate-400">Seleccionar Enemigo</label>
        <select
          value={selectedEnemyId || ''}
          onChange={(e) => setSelectedEnemyId(parseInt(e.target.value))}
          className="w-full bg-slate-900/50 border border-slate-700 rounded-xl p-3 text-white text-sm focus:border-game-primary focus:outline-none"
        >
          <option value="">-- Elegir enemigo --</option>
          {enemies.map(enemy => (
            <option key={enemy.id} value={enemy.id}>
              {enemy.name} (Nv. {enemy.level})
            </option>
          ))}
        </select>
      </div>

      {/* Info del enemigo seleccionado */}
      {selectedEnemy && (
        <div className="p-4 bg-slate-900/50 rounded-xl border border-slate-700 space-y-3">
          <div className="flex items-center gap-3">
            {selectedEnemy.image && selectedEnemy.image !== 'enemy1.png' ? (
              <img 
                src={`${import.meta.env.VITE_API_URL || ''}/uploads/gallery/${selectedEnemy.image}`} 
                alt={selectedEnemy.name} 
                className="w-12 h-12 rounded-lg object-cover border border-slate-600"
              />
            ) : (
              <div className="w-12 h-12 rounded-lg bg-rose-500/10 flex items-center justify-center border border-rose-500/20">
                <Skull size={24} className="text-rose-400" />
              </div>
            )}
            <div>
              <p className="text-sm text-white font-bold uppercase">{selectedEnemy.name}</p>
              <p className="text-xs text-rose-400 font-semibold">Nivel {selectedEnemy.level}</p>
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 gap-2 text-xs">
            <div className="flex items-center gap-2 text-slate-400">
              <Shield size={12} className="text-blue-400" />
              <span>HP Total: <span className="text-white font-bold">{getTotalHP(selectedEnemy)}</span></span>
            </div>
            <div className="flex items-center gap-2 text-slate-400">
              <Zap size={12} className="text-yellow-400" />
              <span>EXP: <span className="text-white font-bold">{selectedEnemy.experience_reward}</span></span>
            </div>
            <div className="flex items-center gap-2 text-slate-400">
              <Sword size={12} className="text-amber-400" />
              <span>Oro: <span className="text-white font-bold">{selectedEnemy.money_reward} G</span></span>
            </div>
          </div>

          {/* Vida por parte */}
          <div className="space-y-1 text-[10px] text-slate-500">
            <div className="flex justify-between">
              <span>Cabeza:</span>
              <span className="text-white">{selectedEnemy.v_head}</span>
            </div>
            <div className="flex justify-between">
              <span>Torso:</span>
              <span className="text-white">{selectedEnemy.v_torso}</span>
            </div>
            <div className="flex justify-between">
              <span>Brazos:</span>
              <span className="text-white">{selectedEnemy.v_arm_l} / {selectedEnemy.v_arm_r}</span>
            </div>
            <div className="flex justify-between">
              <span>Piernas:</span>
              <span className="text-white">{selectedEnemy.v_leg_l} / {selectedEnemy.v_leg_r}</span>
            </div>
          </div>
        </div>
      )}

      {/* Lista de enemigos en este sector */}
      {enemyInstances.length > 0 && (
        <div className="space-y-2">
          <label className="text-xs font-semibold text-slate-400">Enemigos en este Sector</label>
          <div className="max-h-40 overflow-y-auto space-y-1 custom-scrollbar">
            {enemyInstances.map((instance, idx) => (
              <div 
                key={instance.id || idx} 
                className="p-2 bg-slate-900/30 rounded-lg border border-slate-800 text-xs flex justify-between items-center"
              >
                <span className="text-slate-300">{instance.name || `Enemigo #${instance.id_enemy || idx + 1}`}</span>
                <span className="text-slate-500">Coord: {instance.coordinate}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Instrucciones */}
      <div className="p-3 bg-rose-500/5 rounded-xl border border-rose-500/20">
        <p className="text-[10px] text-rose-400">
          ⚔️ Selecciona un enemigo y haz clic en el mapa para colocarlo. Los enemigos no se pueden colocar en agua, montañas o ciudades.
        </p>
      </div>
    </section>
  );
};

export default EnemyPlacer;
